import i18n from 'src/i18n';

const configTable = () => {
  const tableColumns = [
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      sortable: true,
      minWidth: 180,
    },
    {
      prop: 'description',
      label: i18n.t('common_words.description'),
      sortable: true,
      align: 'center',
      minWidth: 250,
    },
  ];

  return { tableColumns };
};

export default configTable;
